module.exports = "/static/media/home_nav_shadow.e855bf45.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/home_nav_shadow.png
// module id = 1893
// module chunks = 0